import { PERMISSION_LABELS } from '../cells/PermissionsCell.helpers';
import { TPermissions } from '../cells/PermissionsCell.types';

export type TEditUserFormValues = {
  permissions: TPermissions;
};

export const diffPermissions = (
  current: TPermissions,
  next: TPermissions,
): Partial<TPermissions> => {
  const changed: Partial<TPermissions> = {};
  PERMISSION_LABELS.forEach((permission) => {
    if (current[permission.key] !== next[permission.key]) {
      changed[permission.key] = next[permission.key];
    }
  });
  return changed;
};
